<mat-card class="card-block" *ngIf="item">
	<mat-card-content>
		<span class="title">Områden</span>
		<span class="badge badge-secondary" *ngFor="let d of districts">{{
			d.name
		}}</span>
		<span class="badge badge-danger" *ngIf="error">{{ error }}</span>
	</mat-card-content>
</mat-card>
